import paymentApi from "@/api/paymentApi";
import { mapTBankRecurentStatusDtoToDomain, TBankRecurentStatusDomain } from "@/types/TBankRecurentStatus";
import { cancelRecurrentSubscriptionLog, selectSubscriptionLog } from "@/firebase/events";

interface SubscriptionRepository {
    getSubscription: (duration: number, isRecurrent: boolean) => Promise<string | null>;
    getTBankPaymentRecurrent: () => Promise<TBankRecurentStatusDomain>;
    cancelRecurrent: () => Promise<number>;
}

const subscriptionRepository: SubscriptionRepository = {
    getSubscription: async (duration: number, isRecurrent: boolean) => {
        const response = await paymentApi.createPayment(duration, isRecurrent);
        await selectSubscriptionLog(isRecurrent, duration);
        return response;
    },
    getTBankPaymentRecurrent: async () => {
        const response = await paymentApi.getTBankPaymentRecurrent();
        return mapTBankRecurentStatusDtoToDomain(response);
    },
    cancelRecurrent: async () => {
        const response = await paymentApi.cancelRecurrent();
        await cancelRecurrentSubscriptionLog();
        return response;
    }
}

export default subscriptionRepository;  